
// 包含所有的图表
export const chartsArray = [
    {
        'label':'折线图',
        'value': 'Blinechart'
    },
    {
        'label':'饼状图',
        'value': "circular"
    },
    {
        'label':'柱状图',
        'value': "barChart"
    },
    {
        'label':'地图',
        'value': "mapChar"
    },
    {
        'label':'关系图',
        'value': "parelchart"
    },
    {
        'label':'词云图',
        'value': "char"
    },
    {
        'label':'图片',
        'value': "pictureCom"
    },
    {
        'label':'视频',
        'value': 21
    },
]